import React from "react";
import { Routes, Route } from "react-router-dom";
import GetDl from "./GetDl";
import GetForm24 from "./GetForm24";
import Layout from "./Layout";
import Transactions from "./Transactions";
import UserDashboard from "./UserDashboard";

const UserRoutes = () => {
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={
          <Layout>
            <UserDashboard />
          </Layout>
        }
      />
      <Route
        exact
        path="/get-dl"
        element={
          <Layout>
            <GetDl />
          </Layout>
        }
      />
      <Route
        exact
        path="/get-form24"
        element={
          <Layout>
            <GetForm24 />
          </Layout>
        }
      />
      <Route
        exact
        path="/all-transactions"
        element={
          <Layout>
            <Transactions />
          </Layout>
        }
      />
    </Routes>
  );
};

export default UserRoutes;
